<div style="background-color: #ff0000; border-radius: 10px; padding: 15px">
  <div class="row align-items-center">
    <div class="col-auto">
      <div
        class="d-inline-block text-center"
        style="
          background-color: #ffffff33;
          width: 40px;
          height: 40px;
          border-radius: 20px;
          padding-top: 10px;
        "
      >
        <i class="color-white {{ icon }} fs-18"></i>
      </div>
    </div>
    <div class="col">
      <ion-label class="color-white">{{ name }}</ion-label>
    </div>
  </div>
</div>
